import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  object-fit: ", ";\n  -webkit-filter: blur(", ");\n  filter: blur(", ");\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import Image from './Image';
import ImageContainer, { imageContainerMixin } from './ImageContainer';
import { getPx } from '../helpers/common';
import { getPreviewUrl } from './helpers';
import { useMeasure } from '../hooks';
import { IMAGE_BLUR_RADIUS } from './constants';
var StyledPreviewImage = styled.img(_templateObject(), function (_ref) {
  var _ref$$fit = _ref.$fit,
      $fit = _ref$$fit === void 0 ? 'cover' : _ref$$fit;
  return $fit;
}, getPx(IMAGE_BLUR_RADIUS), getPx(IMAGE_BLUR_RADIUS), imageContainerMixin);

var ImageResizeAware = function ImageResizeAware(_ref2) {
  var _ref2$ready = _ref2.ready,
      ready = _ref2$ready === void 0 ? true : _ref2$ready,
      _ref2$preview = _ref2.preview,
      preview = _ref2$preview === void 0 ? true : _ref2$preview,
      backgroundColor = _ref2.backgroundColor,
      className = _ref2.className,
      _ref2$fit = _ref2.fit,
      fit = _ref2$fit === void 0 ? 'cover' : _ref2$fit,
      props = _objectWithoutPropertiesLoose(_ref2, ["ready", "preview", "backgroundColor", "className", "fit"]);

  var _useMeasure = useMeasure(),
      setRef = _useMeasure.setRef,
      bounds = _useMeasure.bounds;

  return /*#__PURE__*/React.createElement(ImageContainer, {
    ref: setRef,
    className: className,
    backgroundColor: backgroundColor
  }, bounds.width && bounds.height && ready ?
  /*#__PURE__*/
  // render proper image when size is defined
  React.createElement(Image, _extends({
    preview: preview,
    width: bounds.width,
    height: bounds.height,
    fit: fit
  }, props)) : // render blurry preview image or no preview at all if size is not measured yet
  preview ? /*#__PURE__*/React.createElement(StyledPreviewImage, {
    src: getPreviewUrl(props),
    alt: props.alt,
    $fit: fit
  }) : null);
};

export default ImageResizeAware;